<template>
  <b-modal
      id="update-share-cseit"
      :title="_.get(shareRecord, 'scseit.id') + ' shared with ' + _.get(shareRecord, 'sgroup.groupName')"
      header-bg-variant="success"
      header-text-variant="light"
      size="lg"
      :visible="showModal"
      centered
    >
    <b-row>
      <b-col>
        <br>
        <b>Created At: </b> {{ $moment.unix(_.get(shareRecord, 'createdAt', 1000) / 1000).format("MM/DD/YYYY") }}
        <br>
        <b>Last Updated: </b> {{ $moment.unix(_.get(shareRecord, 'updatedAt', 1000) / 1000).format("MM/DD/YYYY") }}
        <br>
        <b>Current Status: </b> {{ _.get(shareRecord, 'cseitShareStatus', false) ? 'Shared' : 'Not Shared' }}
        <br>
      </b-col>
    </b-row>
    <div slot="modal-footer" class="w-100"></div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'update-share-cseit-modal',
  props: {
    cseitId: Number,
    cseitOrganizationOwner: Number,
    shareRecord: Object,
    showModal: Boolean
  },
  computed: {
    ...mapGetters({
      userCurrentContext: 'userCurrentContext',
      cseitRecord: 'getViewCseit'
    }),
    isShared: function () {
      return _.get(this.shareRecord, 'cseitShareStatus', false)
    }
  },
  created () {
    if (this.cseitId && _.isInteger(this.cseitId)) {
      this.$store.dispatch('getViewCseit', {
        _id: this.cseitId
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Share/UpdateShareCseitModal.vue